var map = {
	"./team-amanda-and-nour.png": 4574,
	"./team-amanda-and-nour.webp": 8663,
	"./team-christopher.png": 846,
	"./team-christopher.webp": 9447,
	"./team-cindy.png": 4174,
	"./team-cindy.webp": 5815,
	"./team-mustafa.png": 6558,
	"./team-mustafa.webp": 8583,
	"./team-omar.png": 3804,
	"./team-omar.webp": 8145,
	"./team-shahin.png": 4486,
	"./team-shahin.webp": 1919
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8713;